'use client'

import * as React from 'react'
import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { Button } from '@/components/ui/button'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = React.useState(false)

  // Avoid hydration mismatch
  React.useEffect(() => {
    setMounted(true)
  }, [])

  /** Без рамки: в базовой кнопке включён focus-visible:border-ring — для переключателя темы убираем видимый бордер. */
  const toggleClassName =
    'shrink-0 rounded-md border-0 shadow-none focus-visible:border-transparent'

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" type="button" className={toggleClassName}>
        <Sun className="h-4 w-4" aria-hidden />
        <span className="sr-only">Переключить тему оформления</span>
      </Button>
    )
  }

  const labelTheme = theme === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему'

  return (
    <Button
      variant="ghost"
      size="icon"
      type="button"
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      className={toggleClassName}
      aria-label={labelTheme}
    >
      {theme === 'dark' ? (
        <Sun className="h-4 w-4" aria-hidden />
      ) : (
        <Moon className="h-4 w-4" aria-hidden />
      )}
    </Button>
  )
}

